import { SearchAndCourseFeatureFacade } from '../../search_and_add_courses/facades/search_and_courses_feature_facade';
class PlannedCourseSearchNavigation {
  constructor(
    private $state: ng.ui.IStateService,
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade
  ) {}

  gotoSearch() {
    const state = 'my.schedule.searchandaddcourses';
    this.$state.go(state);
  }
}

angular.module('capability-ng-scheduler').component('plannedCourseSearchNavigation', {
  templateUrl:
    'capability-ng-scheduler/src/components/planned_course_search_navigation/planned_course_search_navigation.html',
  controller: PlannedCourseSearchNavigation
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/planned_course_search_navigation/planned_course_search_navigation.ts